module.exports = __webpack_public_path__ + "img/icon_box_3_1.c8b20bf7.png";